module.exports = __webpack_public_path__ + "assets/img/block-right-2c010f34.png";